export * from './icon-array.module';